//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IPackagesClient {
    /**
     * Retrieves package statuses
     * @param api_version (optional) 
     */
    getPackageStatusesForDropdown(api_version?: string | null | undefined): Observable<SwaggerResult<EnumDtoOfUserPackageStatus[]>>;
    /**
     * Fetches user package statistics for admin
     * @param api_version (optional) 
     */
    getPackagesStats(api_version?: string | null | undefined): Observable<SwaggerResult<PackageStatsResponse>>;
    /**
     * Gets company packages.
     * @param api_version (optional) 
     */
    getCompanyPackages(api_version?: string | null | undefined): Observable<SwaggerResult<CompanyPackagesResponse>>;
    /**
     * Gets individual packages.
     * @param api_version (optional) 
     */
    getIndividualPackages(api_version?: string | null | undefined): Observable<SwaggerResult<IndividualPackagesResponse>>;
    /**
     * Creates packages purchase request.
     * @param packageId (optional) 
     * @param api_version (optional) 
     */
    buyPackage(packageId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Fetches current company package stats for admin
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getCompanyPackageStatsForAdmin(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<CompanyPackageStatsForAdminResponse>>;
    /**
     * Fetches user package details for admin
     * @param id (optional) 
     * @param api_version (optional) 
     */
    getPackageForAdmin(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<PackageForAdminResponse>>;
    /**
     * Fetches user package for individual
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getPackagesForIndividual(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<PackageForIndividualResponse>>;
    /**
     * Fetches all user packages for admin
     * @param api_version (optional) 
     */
    getPackagesForAdmin(request: GetPackagesForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfPackageForAdminTableResponseAndInteger>>;
    /**
     * Fetches paginated company packages for admin
     * @param api_version (optional) 
     */
    getCompanyPackagesForAdmin(request: GetCompanyPackagesForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfCompanyPackageTableResponse>>;
    /**
     * Fetches all user packages for company
     * @param api_version (optional) 
     */
    getPackagesForCompany(request: GetPackagesForCompanyQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfPackageForCompanyTableResponse>>;
    /**
     * Changes user package status.
     * @param api_version (optional) 
     */
    setStatus(req: SetUserPackageStatusCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class PackagesClient implements IPackagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves package statuses
     * @param api_version (optional) 
     */
    getPackageStatusesForDropdown(api_version?: string | null | undefined): Observable<SwaggerResult<EnumDtoOfUserPackageStatus[]>> {
        let url_ = this.baseUrl + "/api/packages/package-statuses?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageStatusesForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageStatusesForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<EnumDtoOfUserPackageStatus[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<EnumDtoOfUserPackageStatus[]>>;
        }));
    }

    protected processGetPackageStatusesForDropdown(response: HttpResponseBase): Observable<SwaggerResult<EnumDtoOfUserPackageStatus[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumDtoOfUserPackageStatus.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<EnumDtoOfUserPackageStatus[]>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches user package statistics for admin
     * @param api_version (optional) 
     */
    getPackagesStats(api_version?: string | null | undefined): Observable<SwaggerResult<PackageStatsResponse>> {
        let url_ = this.baseUrl + "/api/packages/stats?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackagesStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackagesStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PackageStatsResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PackageStatsResponse>>;
        }));
    }

    protected processGetPackagesStats(response: HttpResponseBase): Observable<SwaggerResult<PackageStatsResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageStatsResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PackageStatsResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets company packages.
     * @param api_version (optional) 
     */
    getCompanyPackages(api_version?: string | null | undefined): Observable<SwaggerResult<CompanyPackagesResponse>> {
        let url_ = this.baseUrl + "/api/packages/company-packages?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<CompanyPackagesResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<CompanyPackagesResponse>>;
        }));
    }

    protected processGetCompanyPackages(response: HttpResponseBase): Observable<SwaggerResult<CompanyPackagesResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyPackagesResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<CompanyPackagesResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets individual packages.
     * @param api_version (optional) 
     */
    getIndividualPackages(api_version?: string | null | undefined): Observable<SwaggerResult<IndividualPackagesResponse>> {
        let url_ = this.baseUrl + "/api/packages/individual-packages?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIndividualPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIndividualPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<IndividualPackagesResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<IndividualPackagesResponse>>;
        }));
    }

    protected processGetIndividualPackages(response: HttpResponseBase): Observable<SwaggerResult<IndividualPackagesResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndividualPackagesResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<IndividualPackagesResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Creates packages purchase request.
     * @param packageId (optional) 
     * @param api_version (optional) 
     */
    buyPackage(packageId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/packages/buy-package?";
        if (packageId === null)
            throw new globalThis.Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processBuyPackage(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches current company package stats for admin
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getCompanyPackageStatsForAdmin(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<CompanyPackageStatsForAdminResponse>> {
        let url_ = this.baseUrl + "/api/packages/company-package-stats-for-admin?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyPackageStatsForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyPackageStatsForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<CompanyPackageStatsForAdminResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<CompanyPackageStatsForAdminResponse>>;
        }));
    }

    protected processGetCompanyPackageStatsForAdmin(response: HttpResponseBase): Observable<SwaggerResult<CompanyPackageStatsForAdminResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyPackageStatsForAdminResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<CompanyPackageStatsForAdminResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches user package details for admin
     * @param id (optional) 
     * @param api_version (optional) 
     */
    getPackageForAdmin(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<PackageForAdminResponse>> {
        let url_ = this.baseUrl + "/api/packages/get-for-admin?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PackageForAdminResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PackageForAdminResponse>>;
        }));
    }

    protected processGetPackageForAdmin(response: HttpResponseBase): Observable<SwaggerResult<PackageForAdminResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageForAdminResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PackageForAdminResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches user package for individual
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getPackagesForIndividual(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<PackageForIndividualResponse>> {
        let url_ = this.baseUrl + "/api/packages/get-for-individual?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackagesForIndividual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackagesForIndividual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PackageForIndividualResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PackageForIndividualResponse>>;
        }));
    }

    protected processGetPackagesForIndividual(response: HttpResponseBase): Observable<SwaggerResult<PackageForIndividualResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageForIndividualResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PackageForIndividualResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches all user packages for admin
     * @param api_version (optional) 
     */
    getPackagesForAdmin(request: GetPackagesForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfPackageForAdminTableResponseAndInteger>> {
        let url_ = this.baseUrl + "/api/packages/get-table-for-admin?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackagesForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackagesForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PaginationResponseOfPackageForAdminTableResponseAndInteger>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PaginationResponseOfPackageForAdminTableResponseAndInteger>>;
        }));
    }

    protected processGetPackagesForAdmin(response: HttpResponseBase): Observable<SwaggerResult<PaginationResponseOfPackageForAdminTableResponseAndInteger>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfPackageForAdminTableResponseAndInteger.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PaginationResponseOfPackageForAdminTableResponseAndInteger>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches paginated company packages for admin
     * @param api_version (optional) 
     */
    getCompanyPackagesForAdmin(request: GetCompanyPackagesForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfCompanyPackageTableResponse>> {
        let url_ = this.baseUrl + "/api/packages/get-company-packages-table-for-admin?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyPackagesForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyPackagesForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PaginationResponseOfCompanyPackageTableResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PaginationResponseOfCompanyPackageTableResponse>>;
        }));
    }

    protected processGetCompanyPackagesForAdmin(response: HttpResponseBase): Observable<SwaggerResult<PaginationResponseOfCompanyPackageTableResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfCompanyPackageTableResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PaginationResponseOfCompanyPackageTableResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches all user packages for company
     * @param api_version (optional) 
     */
    getPackagesForCompany(request: GetPackagesForCompanyQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfPackageForCompanyTableResponse>> {
        let url_ = this.baseUrl + "/api/packages/get-table-for-company?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackagesForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackagesForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PaginationResponseOfPackageForCompanyTableResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PaginationResponseOfPackageForCompanyTableResponse>>;
        }));
    }

    protected processGetPackagesForCompany(response: HttpResponseBase): Observable<SwaggerResult<PaginationResponseOfPackageForCompanyTableResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfPackageForCompanyTableResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PaginationResponseOfPackageForCompanyTableResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Changes user package status.
     * @param api_version (optional) 
     */
    setStatus(req: SetUserPackageStatusCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/packages/set-user-package-status?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processSetStatus(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface INotificationsClient {
    /**
     * Fetches paginated notifications for the current user.
     * @param api_version (optional) 
     */
    getForUser(request: GetNotificationsQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfNotificationResponse>>;
    /**
     * Fetches the current user's unread notification count.
     * @param api_version (optional) 
     */
    getUnreadCount(api_version?: string | null | undefined): Observable<SwaggerResult<number>>;
    /**
     * Marks a single notification as read.
     * @param api_version (optional) 
     */
    markAsRead(id: string, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Marks all of the current user's notifications as read.
     * @param api_version (optional) 
     */
    markAllAsRead(api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsClient implements INotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Fetches paginated notifications for the current user.
     * @param api_version (optional) 
     */
    getForUser(request: GetNotificationsQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfNotificationResponse>> {
        let url_ = this.baseUrl + "/api/notifications/get-for-user?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PaginationResponseOfNotificationResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PaginationResponseOfNotificationResponse>>;
        }));
    }

    protected processGetForUser(response: HttpResponseBase): Observable<SwaggerResult<PaginationResponseOfNotificationResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfNotificationResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PaginationResponseOfNotificationResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches the current user's unread notification count.
     * @param api_version (optional) 
     */
    getUnreadCount(api_version?: string | null | undefined): Observable<SwaggerResult<number>> {
        let url_ = this.baseUrl + "/api/notifications/unread-count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<number>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<number>>;
        }));
    }

    protected processGetUnreadCount(response: HttpResponseBase): Observable<SwaggerResult<number>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<number>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Marks a single notification as read.
     * @param api_version (optional) 
     */
    markAsRead(id: string, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/notifications/{id}/mark-read?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Marks all of the current user's notifications as read.
     * @param api_version (optional) 
     */
    markAllAsRead(api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/notifications/mark-all-read?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processMarkAllAsRead(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface IAdminsClient {
    /**
     * Gets admin list.
     * @param api_version (optional) 
     */
    getAdmins(api_version?: string | null | undefined): Observable<SwaggerResult<AdminsResponse>>;
    /**
     * Gets aggregated admin dashboard metrics for the given date range
     * @param from (optional) 
     * @param to (optional) 
     * @param api_version (optional) 
     */
    getAdminDashboard(from?: Date | undefined, to?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AdminDashboardResponse>>;
    /**
     * Invites admins.
     * @param api_version (optional) 
     */
    inviteAdmins(req: InviteAdminsCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Deactivates an admin.
     * @param id (optional) 
     * @param api_version (optional) 
     */
    deactivateAdmin(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminsClient implements IAdminsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets admin list.
     * @param api_version (optional) 
     */
    getAdmins(api_version?: string | null | undefined): Observable<SwaggerResult<AdminsResponse>> {
        let url_ = this.baseUrl + "/api/admins/admins?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AdminsResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AdminsResponse>>;
        }));
    }

    protected processGetAdmins(response: HttpResponseBase): Observable<SwaggerResult<AdminsResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminsResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AdminsResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets aggregated admin dashboard metrics for the given date range
     * @param from (optional) 
     * @param to (optional) 
     * @param api_version (optional) 
     */
    getAdminDashboard(from?: Date | undefined, to?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AdminDashboardResponse>> {
        let url_ = this.baseUrl + "/api/admins/dashboard?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AdminDashboardResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AdminDashboardResponse>>;
        }));
    }

    protected processGetAdminDashboard(response: HttpResponseBase): Observable<SwaggerResult<AdminDashboardResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminDashboardResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AdminDashboardResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Invites admins.
     * @param api_version (optional) 
     */
    inviteAdmins(req: InviteAdminsCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/admins/invite?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processInviteAdmins(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Deactivates an admin.
     * @param id (optional) 
     * @param api_version (optional) 
     */
    deactivateAdmin(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/admins/deactivate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processDeactivateAdmin(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface IClientsClient {
    /**
     * Gets client statistics.
     * @param api_version (optional) 
     */
    getClientStats(api_version?: string | null | undefined): Observable<SwaggerResult<ClientStatsResponse>>;
    /**
     * Gets client user data by id.
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getClient(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<ClientInfoResponse>>;
    /**
     * Gets clients grouped by type for autocomplete.
     * @param keyword (optional) 
     * @param api_version (optional) 
     */
    getClientsAutocomplete(keyword?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<ClientsAutocompleteGroupResponse[]>>;
    /**
     * Gets paginated client list for admin.
     * @param api_version (optional) 
     */
    getClientsForAdmin(request: GetClientsForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfClientForAdminTableResponse>>;
}

@Injectable({
    providedIn: 'root'
})
export class ClientsClient implements IClientsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets client statistics.
     * @param api_version (optional) 
     */
    getClientStats(api_version?: string | null | undefined): Observable<SwaggerResult<ClientStatsResponse>> {
        let url_ = this.baseUrl + "/api/clients/stats?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<ClientStatsResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<ClientStatsResponse>>;
        }));
    }

    protected processGetClientStats(response: HttpResponseBase): Observable<SwaggerResult<ClientStatsResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientStatsResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<ClientStatsResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets client user data by id.
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getClient(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<ClientInfoResponse>> {
        let url_ = this.baseUrl + "/api/clients/get-client?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<ClientInfoResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<ClientInfoResponse>>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<SwaggerResult<ClientInfoResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInfoResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<ClientInfoResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets clients grouped by type for autocomplete.
     * @param keyword (optional) 
     * @param api_version (optional) 
     */
    getClientsAutocomplete(keyword?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<ClientsAutocompleteGroupResponse[]>> {
        let url_ = this.baseUrl + "/api/clients/autocomplete?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<ClientsAutocompleteGroupResponse[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<ClientsAutocompleteGroupResponse[]>>;
        }));
    }

    protected processGetClientsAutocomplete(response: HttpResponseBase): Observable<SwaggerResult<ClientsAutocompleteGroupResponse[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientsAutocompleteGroupResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<ClientsAutocompleteGroupResponse[]>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets paginated client list for admin.
     * @param api_version (optional) 
     */
    getClientsForAdmin(request: GetClientsForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfClientForAdminTableResponse>> {
        let url_ = this.baseUrl + "/api/clients/get-table-for-admin?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PaginationResponseOfClientForAdminTableResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PaginationResponseOfClientForAdminTableResponse>>;
        }));
    }

    protected processGetClientsForAdmin(response: HttpResponseBase): Observable<SwaggerResult<PaginationResponseOfClientForAdminTableResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfClientForAdminTableResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PaginationResponseOfClientForAdminTableResponse>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface ICompaniesClient {
    /**
     * Gets company info.
     * @param api_version (optional) 
     */
    getCompanyInfo(api_version?: string | null | undefined): Observable<SwaggerResult<CompanyInfoResponse>>;
    /**
     * Gets aggregated company dashboard metrics for the current user.
     * @param api_version (optional) 
     */
    getCompanyDashboard(api_version?: string | null | undefined): Observable<SwaggerResult<CompanyDashboardResponse>>;
    /**
     * Updates company info.
     * @param api_version (optional) 
     */
    updateCompanyInfo(req: UpdateCompanyInfoCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Updates contact info.
     * @param api_version (optional) 
     */
    updateContact(req: UpdateContactCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class CompaniesClient implements ICompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets company info.
     * @param api_version (optional) 
     */
    getCompanyInfo(api_version?: string | null | undefined): Observable<SwaggerResult<CompanyInfoResponse>> {
        let url_ = this.baseUrl + "/api/companies/profile?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<CompanyInfoResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<CompanyInfoResponse>>;
        }));
    }

    protected processGetCompanyInfo(response: HttpResponseBase): Observable<SwaggerResult<CompanyInfoResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyInfoResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<CompanyInfoResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets aggregated company dashboard metrics for the current user.
     * @param api_version (optional) 
     */
    getCompanyDashboard(api_version?: string | null | undefined): Observable<SwaggerResult<CompanyDashboardResponse>> {
        let url_ = this.baseUrl + "/api/companies/dashboard?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<CompanyDashboardResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<CompanyDashboardResponse>>;
        }));
    }

    protected processGetCompanyDashboard(response: HttpResponseBase): Observable<SwaggerResult<CompanyDashboardResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDashboardResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<CompanyDashboardResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Updates company info.
     * @param api_version (optional) 
     */
    updateCompanyInfo(req: UpdateCompanyInfoCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/companies/company?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processUpdateCompanyInfo(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Updates contact info.
     * @param api_version (optional) 
     */
    updateContact(req: UpdateContactCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/companies/contact?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processUpdateContact(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface IIndividualsClient {
    /**
     * Gets individual info.
     * @param api_version (optional) 
     */
    getIndividualInfo(api_version?: string | null | undefined): Observable<SwaggerResult<IndividualInfoResponse>>;
    /**
     * Updates individual info.
     * @param api_version (optional) 
     */
    updateIndividualInfo(req: UpdateIndividualInfoCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class IndividualsClient implements IIndividualsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets individual info.
     * @param api_version (optional) 
     */
    getIndividualInfo(api_version?: string | null | undefined): Observable<SwaggerResult<IndividualInfoResponse>> {
        let url_ = this.baseUrl + "/api/individuals/profile?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIndividualInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIndividualInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<IndividualInfoResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<IndividualInfoResponse>>;
        }));
    }

    protected processGetIndividualInfo(response: HttpResponseBase): Observable<SwaggerResult<IndividualInfoResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndividualInfoResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<IndividualInfoResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Updates individual info.
     * @param api_version (optional) 
     */
    updateIndividualInfo(req: UpdateIndividualInfoCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/individuals?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIndividualInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIndividualInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processUpdateIndividualInfo(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface ILoginUsersClient {
    /**
     * Request a password reset email for a user.
     * @param email (optional) 
     * @param api_version (optional) 
     */
    sendResetPasswordEmail(email?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Resend the email verification link for an unverified user.
     * @param email (optional) 
     * @param api_version (optional) 
     */
    sendEmailVerification(email?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Verifies the invitation token received via email and returns access token.
     * @param api_version (optional) 
     */
    verifyInvitationToken(req: VerifyCodeCommand, api_version?: string | null | undefined): Observable<SwaggerResult<TokenResponse>>;
    /**
     * Resets user password.
     * @param api_version (optional) 
     */
    resetPassword(req: ResetPasswordCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Sets user password.
     * @param api_version (optional) 
     */
    setPassword(req: SetPasswordCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class LoginUsersClient implements ILoginUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Request a password reset email for a user.
     * @param email (optional) 
     * @param api_version (optional) 
     */
    sendResetPasswordEmail(email?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/loginusers/send-reset-password-email?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResetPasswordEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResetPasswordEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processSendResetPasswordEmail(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Resend the email verification link for an unverified user.
     * @param email (optional) 
     * @param api_version (optional) 
     */
    sendEmailVerification(email?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/loginusers/send-email-verification?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processSendEmailVerification(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Verifies the invitation token received via email and returns access token.
     * @param api_version (optional) 
     */
    verifyInvitationToken(req: VerifyCodeCommand, api_version?: string | null | undefined): Observable<SwaggerResult<TokenResponse>> {
        let url_ = this.baseUrl + "/api/loginusers/verify-invitation-token?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyInvitationToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyInvitationToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<TokenResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<TokenResponse>>;
        }));
    }

    protected processVerifyInvitationToken(response: HttpResponseBase): Observable<SwaggerResult<TokenResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<TokenResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Resets user password.
     * @param api_version (optional) 
     */
    resetPassword(req: ResetPasswordCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/loginusers/reset-password?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Sets user password.
     * @param api_version (optional) 
     */
    setPassword(req: SetPasswordCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/loginusers/set-password?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface ITokensClient {
    /**
     * Registers user.
     * @param api_version (optional) 
     */
    register(request: RegisterCommand, api_version?: string | null | undefined): Observable<SwaggerResult<ResultOfTokenResponse>>;
    /**
     * Returns login token
     * @param api_version (optional) 
     */
    getToken(request: LoginCommand, api_version?: string | null | undefined): Observable<SwaggerResult<ResultOfTokenResponse>>;
    /**
     * Request an access token using a refresh token.
     * @param api_version (optional) 
     */
    refresh(request: RefreshTokenCommand, api_version?: string | null | undefined): Observable<SwaggerResult<ResultOfTokenResponse>>;
}

@Injectable({
    providedIn: 'root'
})
export class TokensClient implements ITokensClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Registers user.
     * @param api_version (optional) 
     */
    register(request: RegisterCommand, api_version?: string | null | undefined): Observable<SwaggerResult<ResultOfTokenResponse>> {
        let url_ = this.baseUrl + "/api/tokens/register?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<ResultOfTokenResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<ResultOfTokenResponse>>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<SwaggerResult<ResultOfTokenResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<ResultOfTokenResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Returns login token
     * @param api_version (optional) 
     */
    getToken(request: LoginCommand, api_version?: string | null | undefined): Observable<SwaggerResult<ResultOfTokenResponse>> {
        let url_ = this.baseUrl + "/api/tokens/login?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<ResultOfTokenResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<ResultOfTokenResponse>>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<SwaggerResult<ResultOfTokenResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<ResultOfTokenResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Request an access token using a refresh token.
     * @param api_version (optional) 
     */
    refresh(request: RefreshTokenCommand, api_version?: string | null | undefined): Observable<SwaggerResult<ResultOfTokenResponse>> {
        let url_ = this.baseUrl + "/api/tokens/refresh?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<ResultOfTokenResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<ResultOfTokenResponse>>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<SwaggerResult<ResultOfTokenResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<ResultOfTokenResponse>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface IWorkingTimeClient {
    /**
     * Gets working time.
     * @param api_version (optional) 
     */
    getWorkingTime(api_version?: string | null | undefined): Observable<SwaggerResult<WorkingTimeResponse>>;
    /**
     * Sets working time.
     * @param api_version (optional) 
     */
    setWorkingTime(req: SetWorkingTimeCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Gets date overrides.
     * @param api_version (optional) 
     */
    getDateOverrides(api_version?: string | null | undefined): Observable<SwaggerResult<DateOverridesResponse>>;
    /**
     * Sets date overrides.
     * @param api_version (optional) 
     */
    setDateOverrides(req: SetDateOverridesCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class WorkingTimeClient implements IWorkingTimeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets working time.
     * @param api_version (optional) 
     */
    getWorkingTime(api_version?: string | null | undefined): Observable<SwaggerResult<WorkingTimeResponse>> {
        let url_ = this.baseUrl + "/api/workingtime?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkingTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkingTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<WorkingTimeResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<WorkingTimeResponse>>;
        }));
    }

    protected processGetWorkingTime(response: HttpResponseBase): Observable<SwaggerResult<WorkingTimeResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingTimeResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<WorkingTimeResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Sets working time.
     * @param api_version (optional) 
     */
    setWorkingTime(req: SetWorkingTimeCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/workingtime?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetWorkingTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetWorkingTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processSetWorkingTime(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets date overrides.
     * @param api_version (optional) 
     */
    getDateOverrides(api_version?: string | null | undefined): Observable<SwaggerResult<DateOverridesResponse>> {
        let url_ = this.baseUrl + "/api/workingtime/date-overrides?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDateOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDateOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<DateOverridesResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<DateOverridesResponse>>;
        }));
    }

    protected processGetDateOverrides(response: HttpResponseBase): Observable<SwaggerResult<DateOverridesResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateOverridesResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<DateOverridesResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Sets date overrides.
     * @param api_version (optional) 
     */
    setDateOverrides(req: SetDateOverridesCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/workingtime/date-overrides?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDateOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDateOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processSetDateOverrides(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export interface IAppointmentsClient {
    /**
     * Gets available calendar slots for given duration
     * @param userId (optional) 
     * @param duration (optional) 
     * @param isForReschedule (optional) 
     * @param api_version (optional) 
     */
    getCalendarSlots(userId?: string | undefined, duration?: number | undefined, isForReschedule?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<CalendarSlotsResponse>>;
    /**
     * Gets active package hours and allowed appointment durations for booking
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getDataForBooking(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<DataForBookingResponse>>;
    /**
     * Gets appointment statistics for admin and given period
     * @param period (optional) 
     * @param api_version (optional) 
     */
    getAppointmentStatsForAdmin(period?: AppointmentStatsPeriod | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentStatsForAdminResponse>>;
    /**
     * Gets appointment details for admin
     * @param id (optional) 
     * @param api_version (optional) 
     */
    getAppointmentDetailsForAdmin(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentDetailsForAdminResponse>>;
    /**
     * Gets appointment details for users
     * @param id (optional) 
     * @param api_version (optional) 
     */
    getAppointmentDetailsForUser(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentDetailsForUserResponse>>;
    /**
     * Fetches all appointments for admin
     * @param api_version (optional) 
     */
    getAppointmentsForAdmin(request: GetAppointmentsForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfAppointmentForAdminTableResponseAndInteger>>;
    /**
     * Fetches paginated appointments for a client (admin).
     * @param api_version (optional) 
     */
    getClientAppointments(request: GetClientAppointmentsQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfClientAppointmentTableResponse>>;
    /**
     * Fetches appointments overlapping the given date range for the admin calendar view
     * @param from (optional) 
     * @param to (optional) 
     * @param api_version (optional) 
     */
    getAppointmentsForCalendar(from?: Date | undefined, to?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentForCalendarResponse[]>>;
    /**
     * Fetches appointments overlapping the given date range for the client calendar view
     * @param from (optional) 
     * @param to (optional) 
     * @param api_version (optional) 
     */
    getAppointmentsForUserCalendar(from?: Date | undefined, to?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentForUserCalendarResponse[]>>;
    /**
     * Fetches all appointments for user
     * @param isUpcoming (optional) 
     * @param api_version (optional) 
     */
    getAppointmentsForUser(isUpcoming?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentForUserTableResponse[]>>;
    /**
     * Gets a presigned URL for uploading an appointment document (PDF or DWG)
     * @param fileType (optional) 
     * @param api_version (optional) 
     */
    getAppointmentDocumentUploadUrl(fileType?: FileType | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentDocumentUploadUrlResponse>>;
    /**
     * Deletes an appointment document by id
     * @param documentId (optional) 
     * @param api_version (optional) 
     */
    deleteAppointmentDocument(documentId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Adds a document to an existing appointment
     * @param api_version (optional) 
     */
    addAppointmentDocument(request: AddAppointmentDocumentCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Books an appointment
     * @param api_version (optional) 
     */
    bookAppointment(request: BookAppointmentCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Cancels an appointment
     * @param id (optional) 
     * @param api_version (optional) 
     */
    cancelAppointment(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Reschedules an appointment
     * @param api_version (optional) 
     */
    rescheduleAppointment(req: RescheduleAppointmentCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
    /**
     * Marks a past appointment as no-show (admin only, stats)
     * @param id (optional) 
     * @param api_version (optional) 
     */
    markNoShow(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>>;
}

@Injectable({
    providedIn: 'root'
})
export class AppointmentsClient implements IAppointmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets available calendar slots for given duration
     * @param userId (optional) 
     * @param duration (optional) 
     * @param isForReschedule (optional) 
     * @param api_version (optional) 
     */
    getCalendarSlots(userId?: string | undefined, duration?: number | undefined, isForReschedule?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<CalendarSlotsResponse>> {
        let url_ = this.baseUrl + "/api/appointments/calendar-slots?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (duration === null)
            throw new globalThis.Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        if (isForReschedule === null)
            throw new globalThis.Error("The parameter 'isForReschedule' cannot be null.");
        else if (isForReschedule !== undefined)
            url_ += "isForReschedule=" + encodeURIComponent("" + isForReschedule) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<CalendarSlotsResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<CalendarSlotsResponse>>;
        }));
    }

    protected processGetCalendarSlots(response: HttpResponseBase): Observable<SwaggerResult<CalendarSlotsResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarSlotsResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<CalendarSlotsResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets active package hours and allowed appointment durations for booking
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    getDataForBooking(userId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<DataForBookingResponse>> {
        let url_ = this.baseUrl + "/api/appointments/data-for-booking?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataForBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataForBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<DataForBookingResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<DataForBookingResponse>>;
        }));
    }

    protected processGetDataForBooking(response: HttpResponseBase): Observable<SwaggerResult<DataForBookingResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataForBookingResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<DataForBookingResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets appointment statistics for admin and given period
     * @param period (optional) 
     * @param api_version (optional) 
     */
    getAppointmentStatsForAdmin(period?: AppointmentStatsPeriod | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentStatsForAdminResponse>> {
        let url_ = this.baseUrl + "/api/appointments/stats-for-admin?";
        if (period === null)
            throw new globalThis.Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentStatsForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentStatsForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AppointmentStatsForAdminResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AppointmentStatsForAdminResponse>>;
        }));
    }

    protected processGetAppointmentStatsForAdmin(response: HttpResponseBase): Observable<SwaggerResult<AppointmentStatsForAdminResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentStatsForAdminResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AppointmentStatsForAdminResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets appointment details for admin
     * @param id (optional) 
     * @param api_version (optional) 
     */
    getAppointmentDetailsForAdmin(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentDetailsForAdminResponse>> {
        let url_ = this.baseUrl + "/api/appointments/details-for-admin?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentDetailsForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentDetailsForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AppointmentDetailsForAdminResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AppointmentDetailsForAdminResponse>>;
        }));
    }

    protected processGetAppointmentDetailsForAdmin(response: HttpResponseBase): Observable<SwaggerResult<AppointmentDetailsForAdminResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentDetailsForAdminResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AppointmentDetailsForAdminResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets appointment details for users
     * @param id (optional) 
     * @param api_version (optional) 
     */
    getAppointmentDetailsForUser(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentDetailsForUserResponse>> {
        let url_ = this.baseUrl + "/api/appointments/details-for-user?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentDetailsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentDetailsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AppointmentDetailsForUserResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AppointmentDetailsForUserResponse>>;
        }));
    }

    protected processGetAppointmentDetailsForUser(response: HttpResponseBase): Observable<SwaggerResult<AppointmentDetailsForUserResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentDetailsForUserResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AppointmentDetailsForUserResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches all appointments for admin
     * @param api_version (optional) 
     */
    getAppointmentsForAdmin(request: GetAppointmentsForAdminQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfAppointmentForAdminTableResponseAndInteger>> {
        let url_ = this.baseUrl + "/api/appointments/table-for-admin?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentsForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentsForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PaginationResponseOfAppointmentForAdminTableResponseAndInteger>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PaginationResponseOfAppointmentForAdminTableResponseAndInteger>>;
        }));
    }

    protected processGetAppointmentsForAdmin(response: HttpResponseBase): Observable<SwaggerResult<PaginationResponseOfAppointmentForAdminTableResponseAndInteger>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfAppointmentForAdminTableResponseAndInteger.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PaginationResponseOfAppointmentForAdminTableResponseAndInteger>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches paginated appointments for a client (admin).
     * @param api_version (optional) 
     */
    getClientAppointments(request: GetClientAppointmentsQuery, api_version?: string | null | undefined): Observable<SwaggerResult<PaginationResponseOfClientAppointmentTableResponse>> {
        let url_ = this.baseUrl + "/api/appointments/client-appointments?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAppointments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<PaginationResponseOfClientAppointmentTableResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<PaginationResponseOfClientAppointmentTableResponse>>;
        }));
    }

    protected processGetClientAppointments(response: HttpResponseBase): Observable<SwaggerResult<PaginationResponseOfClientAppointmentTableResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfClientAppointmentTableResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<PaginationResponseOfClientAppointmentTableResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches appointments overlapping the given date range for the admin calendar view
     * @param from (optional) 
     * @param to (optional) 
     * @param api_version (optional) 
     */
    getAppointmentsForCalendar(from?: Date | undefined, to?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentForCalendarResponse[]>> {
        let url_ = this.baseUrl + "/api/appointments/calendar?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentsForCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentsForCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AppointmentForCalendarResponse[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AppointmentForCalendarResponse[]>>;
        }));
    }

    protected processGetAppointmentsForCalendar(response: HttpResponseBase): Observable<SwaggerResult<AppointmentForCalendarResponse[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentForCalendarResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AppointmentForCalendarResponse[]>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches appointments overlapping the given date range for the client calendar view
     * @param from (optional) 
     * @param to (optional) 
     * @param api_version (optional) 
     */
    getAppointmentsForUserCalendar(from?: Date | undefined, to?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentForUserCalendarResponse[]>> {
        let url_ = this.baseUrl + "/api/appointments/user-calendar?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentsForUserCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentsForUserCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AppointmentForUserCalendarResponse[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AppointmentForUserCalendarResponse[]>>;
        }));
    }

    protected processGetAppointmentsForUserCalendar(response: HttpResponseBase): Observable<SwaggerResult<AppointmentForUserCalendarResponse[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentForUserCalendarResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AppointmentForUserCalendarResponse[]>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Fetches all appointments for user
     * @param isUpcoming (optional) 
     * @param api_version (optional) 
     */
    getAppointmentsForUser(isUpcoming?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentForUserTableResponse[]>> {
        let url_ = this.baseUrl + "/api/appointments/table-for-user?";
        if (isUpcoming === null)
            throw new globalThis.Error("The parameter 'isUpcoming' cannot be null.");
        else if (isUpcoming !== undefined)
            url_ += "isUpcoming=" + encodeURIComponent("" + isUpcoming) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AppointmentForUserTableResponse[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AppointmentForUserTableResponse[]>>;
        }));
    }

    protected processGetAppointmentsForUser(response: HttpResponseBase): Observable<SwaggerResult<AppointmentForUserTableResponse[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentForUserTableResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AppointmentForUserTableResponse[]>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Gets a presigned URL for uploading an appointment document (PDF or DWG)
     * @param fileType (optional) 
     * @param api_version (optional) 
     */
    getAppointmentDocumentUploadUrl(fileType?: FileType | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<AppointmentDocumentUploadUrlResponse>> {
        let url_ = this.baseUrl + "/api/appointments/document-upload-url?";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentDocumentUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentDocumentUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<AppointmentDocumentUploadUrlResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<AppointmentDocumentUploadUrlResponse>>;
        }));
    }

    protected processGetAppointmentDocumentUploadUrl(response: HttpResponseBase): Observable<SwaggerResult<AppointmentDocumentUploadUrlResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentDocumentUploadUrlResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<AppointmentDocumentUploadUrlResponse>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Deletes an appointment document by id
     * @param documentId (optional) 
     * @param api_version (optional) 
     */
    deleteAppointmentDocument(documentId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/appointments/document?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAppointmentDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAppointmentDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processDeleteAppointmentDocument(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Adds a document to an existing appointment
     * @param api_version (optional) 
     */
    addAppointmentDocument(request: AddAppointmentDocumentCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/appointments/document?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAppointmentDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAppointmentDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processAddAppointmentDocument(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Books an appointment
     * @param api_version (optional) 
     */
    bookAppointment(request: BookAppointmentCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/appointments/book?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processBookAppointment(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Cancels an appointment
     * @param id (optional) 
     * @param api_version (optional) 
     */
    cancelAppointment(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/appointments/cancel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processCancelAppointment(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Reschedules an appointment
     * @param api_version (optional) 
     */
    rescheduleAppointment(req: RescheduleAppointmentCommand, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/appointments/reschedule?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processRescheduleAppointment(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }

    /**
     * Marks a past appointment as no-show (admin only, stats)
     * @param id (optional) 
     * @param api_version (optional) 
     */
    markNoShow(id?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResult<string>> {
        let url_ = this.baseUrl + "/api/appointments/mark-no-show?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNoShow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNoShow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResult<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResult<string>>;
        }));
    }

    protected processMarkNoShow(response: HttpResponseBase): Observable<SwaggerResult<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResult(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResult<string>>(new SwaggerResult(status, _headers, null as any));
    }
}

export class EnumDtoOfUserPackageStatus implements IEnumDtoOfUserPackageStatus {
    description?: string;
    value?: UserPackageStatus;

    constructor(data?: IEnumDtoOfUserPackageStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EnumDtoOfUserPackageStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDtoOfUserPackageStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["value"] = this.value;
        return data;
    }
}

export interface IEnumDtoOfUserPackageStatus {
    description?: string;
    value?: UserPackageStatus;
}

export enum UserPackageStatus {
    NEW = 0,
    INVOICE_SENT = 1,
    ACTIVE = 2,
    CANCELLED = 3,
    EXTENDED = 4,
    EXPIRED = 5,
}

export class PackageStatsResponse implements IPackageStatsResponse {
    totalPackages?: number;
    newPackages?: number;
    awaitingPayment?: number;

    constructor(data?: IPackageStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPackages = _data["totalPackages"];
            this.newPackages = _data["newPackages"];
            this.awaitingPayment = _data["awaitingPayment"];
        }
    }

    static fromJS(data: any): PackageStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PackageStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPackages"] = this.totalPackages;
        data["newPackages"] = this.newPackages;
        data["awaitingPayment"] = this.awaitingPayment;
        return data;
    }
}

export interface IPackageStatsResponse {
    totalPackages?: number;
    newPackages?: number;
    awaitingPayment?: number;
}

export class CompanyPackagesResponse implements ICompanyPackagesResponse {
    packages?: CompanyPackageDto[];

    constructor(data?: ICompanyPackagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(CompanyPackageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyPackagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompanyPackagesResponse {
    packages?: CompanyPackageDto[];
}

export class CompanyPackageDto implements ICompanyPackageDto {
    id?: string;
    price?: number;
    hours?: number;
    pricePerHour?: number;
    numOfUsers?: number;
    nextMonthHourTransfer?: number;
    daysValid?: number;
    daysBookableInAdvance?: number;
    changeHourCutoff?: number;
    noShowPenalty?: number;

    constructor(data?: ICompanyPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.hours = _data["hours"];
            this.pricePerHour = _data["pricePerHour"];
            this.numOfUsers = _data["numOfUsers"];
            this.nextMonthHourTransfer = _data["nextMonthHourTransfer"];
            this.daysValid = _data["daysValid"];
            this.daysBookableInAdvance = _data["daysBookableInAdvance"];
            this.changeHourCutoff = _data["changeHourCutoff"];
            this.noShowPenalty = _data["noShowPenalty"];
        }
    }

    static fromJS(data: any): CompanyPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["hours"] = this.hours;
        data["pricePerHour"] = this.pricePerHour;
        data["numOfUsers"] = this.numOfUsers;
        data["nextMonthHourTransfer"] = this.nextMonthHourTransfer;
        data["daysValid"] = this.daysValid;
        data["daysBookableInAdvance"] = this.daysBookableInAdvance;
        data["changeHourCutoff"] = this.changeHourCutoff;
        data["noShowPenalty"] = this.noShowPenalty;
        return data;
    }
}

export interface ICompanyPackageDto {
    id?: string;
    price?: number;
    hours?: number;
    pricePerHour?: number;
    numOfUsers?: number;
    nextMonthHourTransfer?: number;
    daysValid?: number;
    daysBookableInAdvance?: number;
    changeHourCutoff?: number;
    noShowPenalty?: number;
}

export class IndividualPackagesResponse implements IIndividualPackagesResponse {
    packages?: IndividualPackageDto[];

    constructor(data?: IIndividualPackagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(IndividualPackageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndividualPackagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualPackagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIndividualPackagesResponse {
    packages?: IndividualPackageDto[];
}

export class IndividualPackageDto implements IIndividualPackageDto {
    id?: string;
    price?: number;
    hours?: number;
    pricePerHour?: number;
    numOfUsers?: number;
    daysValid?: number;
    cancellationCutoff?: number;
    cancellationPenalty?: number;

    constructor(data?: IIndividualPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.hours = _data["hours"];
            this.pricePerHour = _data["pricePerHour"];
            this.numOfUsers = _data["numOfUsers"];
            this.daysValid = _data["daysValid"];
            this.cancellationCutoff = _data["cancellationCutoff"];
            this.cancellationPenalty = _data["cancellationPenalty"];
        }
    }

    static fromJS(data: any): IndividualPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["hours"] = this.hours;
        data["pricePerHour"] = this.pricePerHour;
        data["numOfUsers"] = this.numOfUsers;
        data["daysValid"] = this.daysValid;
        data["cancellationCutoff"] = this.cancellationCutoff;
        data["cancellationPenalty"] = this.cancellationPenalty;
        return data;
    }
}

export interface IIndividualPackageDto {
    id?: string;
    price?: number;
    hours?: number;
    pricePerHour?: number;
    numOfUsers?: number;
    daysValid?: number;
    cancellationCutoff?: number;
    cancellationPenalty?: number;
}

export class CompanyPackageStatsForAdminResponse implements ICompanyPackageStatsForAdminResponse {
    availableHours?: number;
    usedHours?: number;
    totalHours?: number;
    usedPercentage?: number;

    constructor(data?: ICompanyPackageStatsForAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availableHours = _data["availableHours"];
            this.usedHours = _data["usedHours"];
            this.totalHours = _data["totalHours"];
            this.usedPercentage = _data["usedPercentage"];
        }
    }

    static fromJS(data: any): CompanyPackageStatsForAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageStatsForAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availableHours"] = this.availableHours;
        data["usedHours"] = this.usedHours;
        data["totalHours"] = this.totalHours;
        data["usedPercentage"] = this.usedPercentage;
        return data;
    }
}

export interface ICompanyPackageStatsForAdminResponse {
    availableHours?: number;
    usedHours?: number;
    totalHours?: number;
    usedPercentage?: number;
}

export class PackageForAdminResponse implements IPackageForAdminResponse {
    userData?: PackageUserData;
    name?: string;
    price?: number;
    createdOn?: Date;
    invoiceSentDateTime?: Date | undefined;
    paymentDateTime?: Date | undefined;
    status?: EnumDtoOfUserPackageStatus;

    constructor(data?: IPackageForAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userData = _data["userData"] ? PackageUserData.fromJS(_data["userData"]) : undefined as any;
            this.name = _data["name"];
            this.price = _data["price"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.invoiceSentDateTime = _data["invoiceSentDateTime"] ? new Date(_data["invoiceSentDateTime"].toString()) : undefined as any;
            this.paymentDateTime = _data["paymentDateTime"] ? new Date(_data["paymentDateTime"].toString()) : undefined as any;
            this.status = _data["status"] ? EnumDtoOfUserPackageStatus.fromJS(_data["status"]) : undefined as any;
        }
    }

    static fromJS(data: any): PackageForAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PackageForAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userData"] = this.userData ? this.userData.toJSON() : undefined as any;
        data["name"] = this.name;
        data["price"] = this.price;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["invoiceSentDateTime"] = this.invoiceSentDateTime ? this.invoiceSentDateTime.toISOString() : undefined as any;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        return data;
    }
}

export interface IPackageForAdminResponse {
    userData?: PackageUserData;
    name?: string;
    price?: number;
    createdOn?: Date;
    invoiceSentDateTime?: Date | undefined;
    paymentDateTime?: Date | undefined;
    status?: EnumDtoOfUserPackageStatus;
}

export class PackageUserData implements IPackageUserData {
    name?: string;
    isCompany?: boolean;
    email?: string;
    phone?: string;
    contactFullName?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    pib?: string | undefined;
    mb?: string | undefined;

    constructor(data?: IPackageUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isCompany = _data["isCompany"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contactFullName = _data["contactFullName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
        }
    }

    static fromJS(data: any): PackageUserData {
        data = typeof data === 'object' ? data : {};
        let result = new PackageUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isCompany"] = this.isCompany;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contactFullName"] = this.contactFullName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        return data;
    }
}

export interface IPackageUserData {
    name?: string;
    isCompany?: boolean;
    email?: string;
    phone?: string;
    contactFullName?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    pib?: string | undefined;
    mb?: string | undefined;
}

export class PackageForIndividualResponse implements IPackageForIndividualResponse {
    id?: string;
    packageName?: string;
    status?: EnumDtoOfUserPackageStatus;
    hours?: number;
    activeAppointments?: number;
    createdOn?: Date;
    invoiceSentOn?: Date | undefined;
    validUntil?: Date | undefined;

    constructor(data?: IPackageForIndividualResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageName = _data["packageName"];
            this.status = _data["status"] ? EnumDtoOfUserPackageStatus.fromJS(_data["status"]) : undefined as any;
            this.hours = _data["hours"];
            this.activeAppointments = _data["activeAppointments"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.invoiceSentOn = _data["invoiceSentOn"] ? new Date(_data["invoiceSentOn"].toString()) : undefined as any;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PackageForIndividualResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PackageForIndividualResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageName"] = this.packageName;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["hours"] = this.hours;
        data["activeAppointments"] = this.activeAppointments;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["invoiceSentOn"] = this.invoiceSentOn ? this.invoiceSentOn.toISOString() : undefined as any;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        return data;
    }
}

export interface IPackageForIndividualResponse {
    id?: string;
    packageName?: string;
    status?: EnumDtoOfUserPackageStatus;
    hours?: number;
    activeAppointments?: number;
    createdOn?: Date;
    invoiceSentOn?: Date | undefined;
    validUntil?: Date | undefined;
}

export class PaginationResponseOfPackageForAdminTableResponse implements IPaginationResponseOfPackageForAdminTableResponse {
    data?: PackageForAdminTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfPackageForAdminTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PackageForAdminTableResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfPackageForAdminTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfPackageForAdminTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfPackageForAdminTableResponse {
    data?: PackageForAdminTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginationResponseOfPackageForAdminTableResponseAndInteger extends PaginationResponseOfPackageForAdminTableResponse implements IPaginationResponseOfPackageForAdminTableResponseAndInteger {
    additionalData?: number;

    constructor(data?: IPaginationResponseOfPackageForAdminTableResponseAndInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalData = _data["additionalData"];
        }
    }

    static override fromJS(data: any): PaginationResponseOfPackageForAdminTableResponseAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfPackageForAdminTableResponseAndInteger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalData"] = this.additionalData;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginationResponseOfPackageForAdminTableResponseAndInteger extends IPaginationResponseOfPackageForAdminTableResponse {
    additionalData?: number;
}

export class PackageForAdminTableResponse implements IPackageForAdminTableResponse {
    id?: string;
    name?: string;
    isCompany?: boolean;
    packageName?: string;
    packagePrice?: number;
    createdOn?: Date;
    status?: EnumDtoOfUserPackageStatus;
    lastActionDateTime?: Date;

    constructor(data?: IPackageForAdminTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompany = _data["isCompany"];
            this.packageName = _data["packageName"];
            this.packagePrice = _data["packagePrice"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.status = _data["status"] ? EnumDtoOfUserPackageStatus.fromJS(_data["status"]) : undefined as any;
            this.lastActionDateTime = _data["lastActionDateTime"] ? new Date(_data["lastActionDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PackageForAdminTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PackageForAdminTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompany"] = this.isCompany;
        data["packageName"] = this.packageName;
        data["packagePrice"] = this.packagePrice;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["lastActionDateTime"] = this.lastActionDateTime ? this.lastActionDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IPackageForAdminTableResponse {
    id?: string;
    name?: string;
    isCompany?: boolean;
    packageName?: string;
    packagePrice?: number;
    createdOn?: Date;
    status?: EnumDtoOfUserPackageStatus;
    lastActionDateTime?: Date;
}

export class PaginationFilter implements IPaginationFilter {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IPaginationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PaginationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPaginationFilter {
    pageNumber?: number;
    pageSize?: number;
}

export class GetPackagesForAdminQuery extends PaginationFilter implements IGetPackagesForAdminQuery {
    filter?: PackageFilter;

    constructor(data?: IGetPackagesForAdminQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filter = _data["filter"] ? PackageFilter.fromJS(_data["filter"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetPackagesForAdminQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackagesForAdminQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackagesForAdminQuery extends IPaginationFilter {
    filter?: PackageFilter;
}

export class PackageFilter implements IPackageFilter {
    statuses?: UserPackageStatus[];
    userId?: string | undefined;
    keyword?: string | undefined;
    isCompany?: boolean | undefined;

    constructor(data?: IPackageFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.userId = _data["userId"];
            this.keyword = _data["keyword"];
            this.isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): PackageFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PackageFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["userId"] = this.userId;
        data["keyword"] = this.keyword;
        data["isCompany"] = this.isCompany;
        return data;
    }
}

export interface IPackageFilter {
    statuses?: UserPackageStatus[];
    userId?: string | undefined;
    keyword?: string | undefined;
    isCompany?: boolean | undefined;
}

export class PaginationResponseOfCompanyPackageTableResponse implements IPaginationResponseOfCompanyPackageTableResponse {
    data?: CompanyPackageTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfCompanyPackageTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CompanyPackageTableResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfCompanyPackageTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfCompanyPackageTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfCompanyPackageTableResponse {
    data?: CompanyPackageTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CompanyPackageTableResponse implements ICompanyPackageTableResponse {
    id?: string;
    name?: string;
    status?: EnumDtoOfUserPackageStatus;
    remainingHours?: number;
    totalHours?: number;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: ICompanyPackageTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"] ? EnumDtoOfUserPackageStatus.fromJS(_data["status"]) : undefined as any;
            this.remainingHours = _data["remainingHours"];
            this.totalHours = _data["totalHours"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CompanyPackageTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["remainingHours"] = this.remainingHours;
        data["totalHours"] = this.totalHours;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        return data;
    }
}

export interface ICompanyPackageTableResponse {
    id?: string;
    name?: string;
    status?: EnumDtoOfUserPackageStatus;
    remainingHours?: number;
    totalHours?: number;
    validFrom?: Date;
    validTo?: Date;
}

export class GetCompanyPackagesForAdminQuery extends PaginationFilter implements IGetCompanyPackagesForAdminQuery {
    filter?: CompanyPackageFilter;

    constructor(data?: IGetCompanyPackagesForAdminQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filter = _data["filter"] ? CompanyPackageFilter.fromJS(_data["filter"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetCompanyPackagesForAdminQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyPackagesForAdminQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCompanyPackagesForAdminQuery extends IPaginationFilter {
    filter?: CompanyPackageFilter;
}

export class CompanyPackageFilter implements ICompanyPackageFilter {
    statuses?: UserPackageStatus[];
    userId?: string | undefined;

    constructor(data?: ICompanyPackageFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CompanyPackageFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICompanyPackageFilter {
    statuses?: UserPackageStatus[];
    userId?: string | undefined;
}

export class PaginationResponseOfPackageForCompanyTableResponse implements IPaginationResponseOfPackageForCompanyTableResponse {
    data?: PackageForCompanyTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfPackageForCompanyTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PackageForCompanyTableResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfPackageForCompanyTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfPackageForCompanyTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfPackageForCompanyTableResponse {
    data?: PackageForCompanyTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PackageForCompanyTableResponse implements IPackageForCompanyTableResponse {
    id?: string;
    packageName?: string;
    status?: EnumDtoOfUserPackageStatus;
    createdOn?: Date;
    nextStep?: string | undefined;
    progress?: UserPackageProgress;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;

    constructor(data?: IPackageForCompanyTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageName = _data["packageName"];
            this.status = _data["status"] ? EnumDtoOfUserPackageStatus.fromJS(_data["status"]) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.nextStep = _data["nextStep"];
            this.progress = _data["progress"] ? UserPackageProgress.fromJS(_data["progress"]) : undefined as any;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PackageForCompanyTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PackageForCompanyTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageName"] = this.packageName;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["nextStep"] = this.nextStep;
        data["progress"] = this.progress ? this.progress.toJSON() : undefined as any;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        return data;
    }
}

export interface IPackageForCompanyTableResponse {
    id?: string;
    packageName?: string;
    status?: EnumDtoOfUserPackageStatus;
    createdOn?: Date;
    nextStep?: string | undefined;
    progress?: UserPackageProgress;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
}

export class UserPackageProgress implements IUserPackageProgress {
    totalHours?: number;
    availableHours?: number;

    constructor(data?: IUserPackageProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalHours = _data["totalHours"];
            this.availableHours = _data["availableHours"];
        }
    }

    static fromJS(data: any): UserPackageProgress {
        data = typeof data === 'object' ? data : {};
        let result = new UserPackageProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalHours"] = this.totalHours;
        data["availableHours"] = this.availableHours;
        return data;
    }
}

export interface IUserPackageProgress {
    totalHours?: number;
    availableHours?: number;
}

export class GetPackagesForCompanyQuery extends PaginationFilter implements IGetPackagesForCompanyQuery {
    filter?: PackageFilter;

    constructor(data?: IGetPackagesForCompanyQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filter = _data["filter"] ? PackageFilter.fromJS(_data["filter"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetPackagesForCompanyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackagesForCompanyQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackagesForCompanyQuery extends IPaginationFilter {
    filter?: PackageFilter;
}

export class SetUserPackageStatusCommand implements ISetUserPackageStatusCommand {
    id!: string;
    status!: UserPackageStatus;
    packagePrice!: UserPackagePriceDto;

    constructor(data?: ISetUserPackageStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.packagePrice = new UserPackagePriceDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.packagePrice = _data["packagePrice"] ? UserPackagePriceDto.fromJS(_data["packagePrice"]) : new UserPackagePriceDto();
        }
    }

    static fromJS(data: any): SetUserPackageStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserPackageStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["packagePrice"] = this.packagePrice ? this.packagePrice.toJSON() : undefined as any;
        return data;
    }
}

export interface ISetUserPackageStatusCommand {
    id: string;
    status: UserPackageStatus;
    packagePrice: UserPackagePriceDto;
}

export class UserPackagePriceDto implements IUserPackagePriceDto {
    originalPrice?: number;
    price?: number;

    constructor(data?: IUserPackagePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalPrice = _data["originalPrice"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): UserPackagePriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPackagePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalPrice"] = this.originalPrice;
        data["price"] = this.price;
        return data;
    }
}

export interface IUserPackagePriceDto {
    originalPrice?: number;
    price?: number;
}

export class PaginationResponseOfNotificationResponse implements IPaginationResponseOfNotificationResponse {
    data?: NotificationResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfNotificationResponse {
    data?: NotificationResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class NotificationResponse implements INotificationResponse {
    id?: string;
    type?: NotificationType;
    title?: string;
    body?: string;
    isRead?: boolean;
    createdOn?: Date;

    constructor(data?: INotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.isRead = _data["isRead"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["body"] = this.body;
        data["isRead"] = this.isRead;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface INotificationResponse {
    id?: string;
    type?: NotificationType;
    title?: string;
    body?: string;
    isRead?: boolean;
    createdOn?: Date;
}

export enum NotificationType {
    NEW_PACKAGE_REQUEST = 0,
    MISSING_FILE = 1,
    INVOICE_SENT = 2,
    PACKAGE_ACTIVATED = 3,
    APPOINTMENT_REMINDER = 4,
    REQUEST_PROCESSING = 5,
}

export class GetNotificationsQuery extends PaginationFilter implements IGetNotificationsQuery {
    unreadOnly?: boolean;

    constructor(data?: IGetNotificationsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unreadOnly = _data["unreadOnly"];
        }
    }

    static override fromJS(data: any): GetNotificationsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadOnly"] = this.unreadOnly;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNotificationsQuery extends IPaginationFilter {
    unreadOnly?: boolean;
}

export class AdminsResponse implements IAdminsResponse {
    admins?: AdminDto[];

    constructor(data?: IAdminsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(AdminDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdminsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminsResponse {
    admins?: AdminDto[];
}

export class AdminDto implements IAdminDto {
    id?: string;
    email?: string;

    constructor(data?: IAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface IAdminDto {
    id?: string;
    email?: string;
}

export class AdminDashboardResponse implements IAdminDashboardResponse {
    occupancy?: OccupancyStats;
    hours?: HourUsageStats;
    revenue?: RevenueStats;
    sessions?: SessionStats;
    cancellation?: CancellationStats;
    monthlyAppointments?: MonthlyAppointmentCount[];
    revenueByPackage?: RevenueByPackagePoint[];
    revenueByClientType?: RevenueByClientTypeStats;
    activeRequests?: ActiveRequestGroup[];

    constructor(data?: IAdminDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occupancy = _data["occupancy"] ? OccupancyStats.fromJS(_data["occupancy"]) : undefined as any;
            this.hours = _data["hours"] ? HourUsageStats.fromJS(_data["hours"]) : undefined as any;
            this.revenue = _data["revenue"] ? RevenueStats.fromJS(_data["revenue"]) : undefined as any;
            this.sessions = _data["sessions"] ? SessionStats.fromJS(_data["sessions"]) : undefined as any;
            this.cancellation = _data["cancellation"] ? CancellationStats.fromJS(_data["cancellation"]) : undefined as any;
            if (Array.isArray(_data["monthlyAppointments"])) {
                this.monthlyAppointments = [] as any;
                for (let item of _data["monthlyAppointments"])
                    this.monthlyAppointments!.push(MonthlyAppointmentCount.fromJS(item));
            }
            if (Array.isArray(_data["revenueByPackage"])) {
                this.revenueByPackage = [] as any;
                for (let item of _data["revenueByPackage"])
                    this.revenueByPackage!.push(RevenueByPackagePoint.fromJS(item));
            }
            this.revenueByClientType = _data["revenueByClientType"] ? RevenueByClientTypeStats.fromJS(_data["revenueByClientType"]) : undefined as any;
            if (Array.isArray(_data["activeRequests"])) {
                this.activeRequests = [] as any;
                for (let item of _data["activeRequests"])
                    this.activeRequests!.push(ActiveRequestGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occupancy"] = this.occupancy ? this.occupancy.toJSON() : undefined as any;
        data["hours"] = this.hours ? this.hours.toJSON() : undefined as any;
        data["revenue"] = this.revenue ? this.revenue.toJSON() : undefined as any;
        data["sessions"] = this.sessions ? this.sessions.toJSON() : undefined as any;
        data["cancellation"] = this.cancellation ? this.cancellation.toJSON() : undefined as any;
        if (Array.isArray(this.monthlyAppointments)) {
            data["monthlyAppointments"] = [];
            for (let item of this.monthlyAppointments)
                data["monthlyAppointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.revenueByPackage)) {
            data["revenueByPackage"] = [];
            for (let item of this.revenueByPackage)
                data["revenueByPackage"].push(item ? item.toJSON() : undefined as any);
        }
        data["revenueByClientType"] = this.revenueByClientType ? this.revenueByClientType.toJSON() : undefined as any;
        if (Array.isArray(this.activeRequests)) {
            data["activeRequests"] = [];
            for (let item of this.activeRequests)
                data["activeRequests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminDashboardResponse {
    occupancy?: OccupancyStats;
    hours?: HourUsageStats;
    revenue?: RevenueStats;
    sessions?: SessionStats;
    cancellation?: CancellationStats;
    monthlyAppointments?: MonthlyAppointmentCount[];
    revenueByPackage?: RevenueByPackagePoint[];
    revenueByClientType?: RevenueByClientTypeStats;
    activeRequests?: ActiveRequestGroup[];
}

export class OccupancyStats implements IOccupancyStats {
    percentage?: number;
    trend?: number;

    constructor(data?: IOccupancyStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.trend = _data["trend"];
        }
    }

    static fromJS(data: any): OccupancyStats {
        data = typeof data === 'object' ? data : {};
        let result = new OccupancyStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["trend"] = this.trend;
        return data;
    }
}

export interface IOccupancyStats {
    percentage?: number;
    trend?: number;
}

export class HourUsageStats implements IHourUsageStats {
    usedHours?: number;
    freeHours?: number;
    totalAvailableHours?: number;

    constructor(data?: IHourUsageStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usedHours = _data["usedHours"];
            this.freeHours = _data["freeHours"];
            this.totalAvailableHours = _data["totalAvailableHours"];
        }
    }

    static fromJS(data: any): HourUsageStats {
        data = typeof data === 'object' ? data : {};
        let result = new HourUsageStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usedHours"] = this.usedHours;
        data["freeHours"] = this.freeHours;
        data["totalAvailableHours"] = this.totalAvailableHours;
        return data;
    }
}

export interface IHourUsageStats {
    usedHours?: number;
    freeHours?: number;
    totalAvailableHours?: number;
}

export class RevenueStats implements IRevenueStats {
    total?: number;
    trend?: number;

    constructor(data?: IRevenueStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.trend = _data["trend"];
        }
    }

    static fromJS(data: any): RevenueStats {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["trend"] = this.trend;
        return data;
    }
}

export interface IRevenueStats {
    total?: number;
    trend?: number;
}

export class SessionStats implements ISessionStats {
    total?: number;
    legalEntityCount?: number;
    individualCount?: number;

    constructor(data?: ISessionStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.legalEntityCount = _data["legalEntityCount"];
            this.individualCount = _data["individualCount"];
        }
    }

    static fromJS(data: any): SessionStats {
        data = typeof data === 'object' ? data : {};
        let result = new SessionStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["legalEntityCount"] = this.legalEntityCount;
        data["individualCount"] = this.individualCount;
        return data;
    }
}

export interface ISessionStats {
    total?: number;
    legalEntityCount?: number;
    individualCount?: number;
}

export class CancellationStats implements ICancellationStats {
    rate?: number;
    trend?: number;

    constructor(data?: ICancellationStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"];
            this.trend = _data["trend"];
        }
    }

    static fromJS(data: any): CancellationStats {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        data["trend"] = this.trend;
        return data;
    }
}

export interface ICancellationStats {
    rate?: number;
    trend?: number;
}

export class MonthlyAppointmentCount implements IMonthlyAppointmentCount {
    year?: number;
    month?: number;
    day?: number | undefined;
    count?: number;

    constructor(data?: IMonthlyAppointmentCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): MonthlyAppointmentCount {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyAppointmentCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        data["count"] = this.count;
        return data;
    }
}

export interface IMonthlyAppointmentCount {
    year?: number;
    month?: number;
    day?: number | undefined;
    count?: number;
}

export class RevenueByPackagePoint implements IRevenueByPackagePoint {
    packageName?: string;
    revenue?: number;

    constructor(data?: IRevenueByPackagePoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageName = _data["packageName"];
            this.revenue = _data["revenue"];
        }
    }

    static fromJS(data: any): RevenueByPackagePoint {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueByPackagePoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageName"] = this.packageName;
        data["revenue"] = this.revenue;
        return data;
    }
}

export interface IRevenueByPackagePoint {
    packageName?: string;
    revenue?: number;
}

export class RevenueByClientTypeStats implements IRevenueByClientTypeStats {
    legalEntityRevenue?: number;
    individualRevenue?: number;

    constructor(data?: IRevenueByClientTypeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalEntityRevenue = _data["legalEntityRevenue"];
            this.individualRevenue = _data["individualRevenue"];
        }
    }

    static fromJS(data: any): RevenueByClientTypeStats {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueByClientTypeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalEntityRevenue"] = this.legalEntityRevenue;
        data["individualRevenue"] = this.individualRevenue;
        return data;
    }
}

export interface IRevenueByClientTypeStats {
    legalEntityRevenue?: number;
    individualRevenue?: number;
}

export class ActiveRequestGroup implements IActiveRequestGroup {
    status?: EnumDtoOfUserPackageStatus;
    count?: number;
    lastRequestDateTime?: Date | undefined;

    constructor(data?: IActiveRequestGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? EnumDtoOfUserPackageStatus.fromJS(_data["status"]) : undefined as any;
            this.count = _data["count"];
            this.lastRequestDateTime = _data["lastRequestDateTime"] ? new Date(_data["lastRequestDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ActiveRequestGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveRequestGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["count"] = this.count;
        data["lastRequestDateTime"] = this.lastRequestDateTime ? this.lastRequestDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IActiveRequestGroup {
    status?: EnumDtoOfUserPackageStatus;
    count?: number;
    lastRequestDateTime?: Date | undefined;
}

export class InviteAdminsCommand implements IInviteAdminsCommand {
    emails!: string[];

    constructor(data?: IInviteAdminsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.emails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): InviteAdminsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteAdminsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IInviteAdminsCommand {
    emails: string[];
}

export class ClientStatsResponse implements IClientStatsResponse {
    totalClients?: number;
    companyClients?: number;
    individualClients?: number;

    constructor(data?: IClientStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalClients = _data["totalClients"];
            this.companyClients = _data["companyClients"];
            this.individualClients = _data["individualClients"];
        }
    }

    static fromJS(data: any): ClientStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalClients"] = this.totalClients;
        data["companyClients"] = this.companyClients;
        data["individualClients"] = this.individualClients;
        return data;
    }
}

export interface IClientStatsResponse {
    totalClients?: number;
    companyClients?: number;
    individualClients?: number;
}

export class ClientInfoResponse implements IClientInfoResponse {
    name?: string;
    isCompany?: boolean;
    email?: string;
    phone?: string;
    contactFullName?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    pib?: string | undefined;
    mb?: string | undefined;

    constructor(data?: IClientInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isCompany = _data["isCompany"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contactFullName = _data["contactFullName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
        }
    }

    static fromJS(data: any): ClientInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isCompany"] = this.isCompany;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contactFullName"] = this.contactFullName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        return data;
    }
}

export interface IClientInfoResponse {
    name?: string;
    isCompany?: boolean;
    email?: string;
    phone?: string;
    contactFullName?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    pib?: string | undefined;
    mb?: string | undefined;
}

export class ClientsAutocompleteGroupResponse implements IClientsAutocompleteGroupResponse {
    label?: string;
    isCompany?: boolean;
    items?: ClientAutocompleteItemResponse[];

    constructor(data?: IClientsAutocompleteGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.isCompany = _data["isCompany"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientAutocompleteItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientsAutocompleteGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientsAutocompleteGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["isCompany"] = this.isCompany;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClientsAutocompleteGroupResponse {
    label?: string;
    isCompany?: boolean;
    items?: ClientAutocompleteItemResponse[];
}

export class ClientAutocompleteItemResponse implements IClientAutocompleteItemResponse {
    id?: string;
    name?: string;

    constructor(data?: IClientAutocompleteItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClientAutocompleteItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAutocompleteItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IClientAutocompleteItemResponse {
    id?: string;
    name?: string;
}

export class PaginationResponseOfClientForAdminTableResponse implements IPaginationResponseOfClientForAdminTableResponse {
    data?: ClientForAdminTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfClientForAdminTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClientForAdminTableResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfClientForAdminTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfClientForAdminTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfClientForAdminTableResponse {
    data?: ClientForAdminTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ClientForAdminTableResponse implements IClientForAdminTableResponse {
    id?: string;
    name?: string;
    isCompany?: boolean;
    remainingHours?: number;
    totalHours?: number;
    upcomingHours?: number;
    allTimeHours?: number;

    constructor(data?: IClientForAdminTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompany = _data["isCompany"];
            this.remainingHours = _data["remainingHours"];
            this.totalHours = _data["totalHours"];
            this.upcomingHours = _data["upcomingHours"];
            this.allTimeHours = _data["allTimeHours"];
        }
    }

    static fromJS(data: any): ClientForAdminTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientForAdminTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompany"] = this.isCompany;
        data["remainingHours"] = this.remainingHours;
        data["totalHours"] = this.totalHours;
        data["upcomingHours"] = this.upcomingHours;
        data["allTimeHours"] = this.allTimeHours;
        return data;
    }
}

export interface IClientForAdminTableResponse {
    id?: string;
    name?: string;
    isCompany?: boolean;
    remainingHours?: number;
    totalHours?: number;
    upcomingHours?: number;
    allTimeHours?: number;
}

export class GetClientsForAdminQuery extends PaginationFilter implements IGetClientsForAdminQuery {
    isCompany?: boolean;
    keyword?: string | undefined;

    constructor(data?: IGetClientsForAdminQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isCompany = _data["isCompany"];
            this.keyword = _data["keyword"];
        }
    }

    static override fromJS(data: any): GetClientsForAdminQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientsForAdminQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCompany"] = this.isCompany;
        data["keyword"] = this.keyword;
        super.toJSON(data);
        return data;
    }
}

export interface IGetClientsForAdminQuery extends IPaginationFilter {
    isCompany?: boolean;
    keyword?: string | undefined;
}

export class CompanyInfoResponse implements ICompanyInfoResponse {
    companyName?: string;
    pib?: string;
    mb?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;

    constructor(data?: ICompanyInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CompanyInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICompanyInfoResponse {
    companyName?: string;
    pib?: string;
    mb?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
}

export class CompanyDashboardResponse implements ICompanyDashboardResponse {
    availableHours?: number;
    totalHours?: number;
    activePackageCount?: number;
    appointmentsThisMonth?: number;
    daysUntilNextAppointment?: number | undefined;
    nextAppointmentDateTime?: Date | undefined;

    constructor(data?: ICompanyDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availableHours = _data["availableHours"];
            this.totalHours = _data["totalHours"];
            this.activePackageCount = _data["activePackageCount"];
            this.appointmentsThisMonth = _data["appointmentsThisMonth"];
            this.daysUntilNextAppointment = _data["daysUntilNextAppointment"];
            this.nextAppointmentDateTime = _data["nextAppointmentDateTime"] ? new Date(_data["nextAppointmentDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CompanyDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availableHours"] = this.availableHours;
        data["totalHours"] = this.totalHours;
        data["activePackageCount"] = this.activePackageCount;
        data["appointmentsThisMonth"] = this.appointmentsThisMonth;
        data["daysUntilNextAppointment"] = this.daysUntilNextAppointment;
        data["nextAppointmentDateTime"] = this.nextAppointmentDateTime ? this.nextAppointmentDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ICompanyDashboardResponse {
    availableHours?: number;
    totalHours?: number;
    activePackageCount?: number;
    appointmentsThisMonth?: number;
    daysUntilNextAppointment?: number | undefined;
    nextAppointmentDateTime?: Date | undefined;
}

export class UpdateCompanyInfoCommand implements IUpdateCompanyInfoCommand {
    name!: string;
    pib!: string;
    mb!: string;
    address!: string;
    city!: string;
    postalCode!: string;

    constructor(data?: IUpdateCompanyInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): UpdateCompanyInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IUpdateCompanyInfoCommand {
    name: string;
    pib: string;
    mb: string;
    address: string;
    city: string;
    postalCode: string;
}

export class UpdateContactCommand implements IUpdateContactCommand {
    firstName!: string;
    lastName!: string;
    email!: string;
    phone!: string;

    constructor(data?: IUpdateContactCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UpdateContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUpdateContactCommand {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

export class IndividualInfoResponse implements IIndividualInfoResponse {
    firstName?: string;
    lastName?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    email?: string;
    phone?: string;

    constructor(data?: IIndividualInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): IndividualInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IIndividualInfoResponse {
    firstName?: string;
    lastName?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    email?: string;
    phone?: string;
}

export class UpdateIndividualInfoCommand implements IUpdateIndividualInfoCommand {
    firstName!: string;
    lastName!: string;
    address!: string;
    city!: string;
    postalCode!: string;
    email!: string;
    phone!: string;

    constructor(data?: IUpdateIndividualInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UpdateIndividualInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIndividualInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUpdateIndividualInfoCommand {
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    postalCode: string;
    email: string;
    phone: string;
}

export class TokenResponse implements ITokenResponse {
    token?: string;
    refreshToken?: string;
    refreshTokenExpiryTime?: Date;

    constructor(data?: ITokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiryTime = _data["refreshTokenExpiryTime"] ? new Date(_data["refreshTokenExpiryTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiryTime"] = this.refreshTokenExpiryTime ? this.refreshTokenExpiryTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ITokenResponse {
    token?: string;
    refreshToken?: string;
    refreshTokenExpiryTime?: Date;
}

export class VerifyCodeCommand implements IVerifyCodeCommand {
    value?: string;
    code?: string;
    type?: ConfirmationCodeType;

    constructor(data?: IVerifyCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.code = _data["code"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): VerifyCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["code"] = this.code;
        data["type"] = this.type;
        return data;
    }
}

export interface IVerifyCodeCommand {
    value?: string;
    code?: string;
    type?: ConfirmationCodeType;
}

export enum ConfirmationCodeType {
    PASSWORD_RESET = 0,
    REGISTRATION = 1,
    EMAIL_CHANGE = 2,
    EMAIL_VERIFY = 3,
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    password!: string;
    confirmPassword!: string;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IResetPasswordCommand {
    password: string;
    confirmPassword: string;
}

export class SetPasswordCommand implements ISetPasswordCommand {
    oldPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: ISetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): SetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface ISetPasswordCommand {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class Result implements IResult {
    isSuccess?: boolean;
    isFailure?: boolean;
    message?: string;
    error?: ErrorDto;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.isFailure = _data["isFailure"];
            this.message = _data["message"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["isFailure"] = this.isFailure;
        data["message"] = this.message;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IResult {
    isSuccess?: boolean;
    isFailure?: boolean;
    message?: string;
    error?: ErrorDto;
}

export class ResultOfTokenResponse extends Result implements IResultOfTokenResponse {
    value?: TokenResponse | undefined;

    constructor(data?: IResultOfTokenResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? TokenResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultOfTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfTokenResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfTokenResponse extends IResult {
    value?: TokenResponse | undefined;
}

export class ErrorDto implements IErrorDto {
    code?: string;
    message?: string;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorDto {
    code?: string;
    message?: string;
}

export class RegisterCommand implements IRegisterCommand {
    firstName!: string;
    lastName!: string;
    phoneNumber?: string;
    address!: string;
    city!: string;
    postalCode!: string;
    email!: string;
    password!: string;
    confirmPassword!: string;
    isLegalEntity?: boolean;
    companyName!: string;
    pib!: string;
    mb!: string;
    origin?: string | undefined;

    constructor(data?: IRegisterCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.isLegalEntity = _data["isLegalEntity"];
            this.companyName = _data["companyName"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): RegisterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["isLegalEntity"] = this.isLegalEntity;
        data["companyName"] = this.companyName;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IRegisterCommand {
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    address: string;
    city: string;
    postalCode: string;
    email: string;
    password: string;
    confirmPassword: string;
    isLegalEntity?: boolean;
    companyName: string;
    pib: string;
    mb: string;
    origin?: string | undefined;
}

export class ErrorResult implements IErrorResult {
    messages?: string[] | undefined;
    source?: string | undefined;
    exception?: string | undefined;
    errorId?: string | undefined;
    supportMessage?: string | undefined;
    statusCode?: number;

    constructor(data?: IErrorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.source = _data["source"];
            this.exception = _data["exception"];
            this.errorId = _data["errorId"];
            this.supportMessage = _data["supportMessage"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): ErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["source"] = this.source;
        data["exception"] = this.exception;
        data["errorId"] = this.errorId;
        data["supportMessage"] = this.supportMessage;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IErrorResult {
    messages?: string[] | undefined;
    source?: string | undefined;
    exception?: string | undefined;
    errorId?: string | undefined;
    supportMessage?: string | undefined;
    statusCode?: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class LoginCommand implements ILoginCommand {
    email!: string;
    password!: string;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginCommand {
    email: string;
    password: string;
}

export class RefreshTokenCommand implements IRefreshTokenCommand {
    token!: string;
    refreshToken!: string;

    constructor(data?: IRefreshTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenCommand {
    token: string;
    refreshToken: string;
}

export class WorkingTimeResponse implements IWorkingTimeResponse {
    from?: string;
    to?: string;
    workingDays?: number[];

    constructor(data?: IWorkingTimeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            if (Array.isArray(_data["workingDays"])) {
                this.workingDays = [] as any;
                for (let item of _data["workingDays"])
                    this.workingDays!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkingTimeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingTimeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        if (Array.isArray(this.workingDays)) {
            data["workingDays"] = [];
            for (let item of this.workingDays)
                data["workingDays"].push(item);
        }
        return data;
    }
}

export interface IWorkingTimeResponse {
    from?: string;
    to?: string;
    workingDays?: number[];
}

export class SetWorkingTimeCommand implements ISetWorkingTimeCommand {
    from!: string;
    to!: string;
    days!: number[];

    constructor(data?: ISetWorkingTimeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.days = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
        }
    }

    static fromJS(data: any): SetWorkingTimeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetWorkingTimeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        return data;
    }
}

export interface ISetWorkingTimeCommand {
    from: string;
    to: string;
    days: number[];
}

export class DateOverridesResponse implements IDateOverridesResponse {
    dateOverrides?: DateOverrideDto[];

    constructor(data?: IDateOverridesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dateOverrides"])) {
                this.dateOverrides = [] as any;
                for (let item of _data["dateOverrides"])
                    this.dateOverrides!.push(DateOverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DateOverridesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateOverridesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dateOverrides)) {
            data["dateOverrides"] = [];
            for (let item of this.dateOverrides)
                data["dateOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDateOverridesResponse {
    dateOverrides?: DateOverrideDto[];
}

export class DateOverrideDto implements IDateOverrideDto {
    date?: Date;
    intervals?: IntervalDto[];

    constructor(data?: IDateOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["intervals"])) {
                this.intervals = [] as any;
                for (let item of _data["intervals"])
                    this.intervals!.push(IntervalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DateOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.intervals)) {
            data["intervals"] = [];
            for (let item of this.intervals)
                data["intervals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDateOverrideDto {
    date?: Date;
    intervals?: IntervalDto[];
}

export class IntervalDto implements IIntervalDto {
    from?: string;
    to?: string;

    constructor(data?: IIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): IntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IIntervalDto {
    from?: string;
    to?: string;
}

export class SetDateOverridesCommand implements ISetDateOverridesCommand {
    dateOverrides?: DateOverrideDto[];

    constructor(data?: ISetDateOverridesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dateOverrides"])) {
                this.dateOverrides = [] as any;
                for (let item of _data["dateOverrides"])
                    this.dateOverrides!.push(DateOverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetDateOverridesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDateOverridesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dateOverrides)) {
            data["dateOverrides"] = [];
            for (let item of this.dateOverrides)
                data["dateOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetDateOverridesCommand {
    dateOverrides?: DateOverrideDto[];
}

export class CalendarSlotsResponse implements ICalendarSlotsResponse {
    slots?: CalendarSlotDto[];

    constructor(data?: ICalendarSlotsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(CalendarSlotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarSlotsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarSlotsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICalendarSlotsResponse {
    slots?: CalendarSlotDto[];
}

export class CalendarSlotDto implements ICalendarSlotDto {
    dateTime?: Date;
    intervals?: IntervalDto[];

    constructor(data?: ICalendarSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
            if (Array.isArray(_data["intervals"])) {
                this.intervals = [] as any;
                for (let item of _data["intervals"])
                    this.intervals!.push(IntervalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        if (Array.isArray(this.intervals)) {
            data["intervals"] = [];
            for (let item of this.intervals)
                data["intervals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICalendarSlotDto {
    dateTime?: Date;
    intervals?: IntervalDto[];
}

export class DataForBookingResponse implements IDataForBookingResponse {
    packageHours?: number;
    durations?: number[];

    constructor(data?: IDataForBookingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageHours = _data["packageHours"];
            if (Array.isArray(_data["durations"])) {
                this.durations = [] as any;
                for (let item of _data["durations"])
                    this.durations!.push(item);
            }
        }
    }

    static fromJS(data: any): DataForBookingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataForBookingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageHours"] = this.packageHours;
        if (Array.isArray(this.durations)) {
            data["durations"] = [];
            for (let item of this.durations)
                data["durations"].push(item);
        }
        return data;
    }
}

export interface IDataForBookingResponse {
    packageHours?: number;
    durations?: number[];
}

export class AppointmentStatsForAdminResponse implements IAppointmentStatsForAdminResponse {
    today?: number;
    scheduled?: number;
    bookingPercentage?: number;

    constructor(data?: IAppointmentStatsForAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.today = _data["today"];
            this.scheduled = _data["scheduled"];
            this.bookingPercentage = _data["bookingPercentage"];
        }
    }

    static fromJS(data: any): AppointmentStatsForAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentStatsForAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["today"] = this.today;
        data["scheduled"] = this.scheduled;
        data["bookingPercentage"] = this.bookingPercentage;
        return data;
    }
}

export interface IAppointmentStatsForAdminResponse {
    today?: number;
    scheduled?: number;
    bookingPercentage?: number;
}

export enum AppointmentStatsPeriod {
    WEEK = 0,
    MONTH = 1,
    YEAR = 2,
}

export class AppointmentDetailsForAdminResponse implements IAppointmentDetailsForAdminResponse {
    id?: string;
    status?: EnumDtoOfAppointmentStatus;
    from?: Date;
    to?: Date;
    duration?: number;
    documents?: DocumentDto[];
    client?: AppointmentUserDto;
    isShortNotice?: boolean;

    constructor(data?: IAppointmentDetailsForAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"] ? EnumDtoOfAppointmentStatus.fromJS(_data["status"]) : undefined as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.duration = _data["duration"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.client = _data["client"] ? AppointmentUserDto.fromJS(_data["client"]) : undefined as any;
            this.isShortNotice = _data["isShortNotice"];
        }
    }

    static fromJS(data: any): AppointmentDetailsForAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDetailsForAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["duration"] = this.duration;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["isShortNotice"] = this.isShortNotice;
        return data;
    }
}

export interface IAppointmentDetailsForAdminResponse {
    id?: string;
    status?: EnumDtoOfAppointmentStatus;
    from?: Date;
    to?: Date;
    duration?: number;
    documents?: DocumentDto[];
    client?: AppointmentUserDto;
    isShortNotice?: boolean;
}

export class EnumDtoOfAppointmentStatus implements IEnumDtoOfAppointmentStatus {
    description?: string;
    value?: AppointmentStatus;

    constructor(data?: IEnumDtoOfAppointmentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EnumDtoOfAppointmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDtoOfAppointmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["value"] = this.value;
        return data;
    }
}

export interface IEnumDtoOfAppointmentStatus {
    description?: string;
    value?: AppointmentStatus;
}

export enum AppointmentStatus {
    ACTIVE = 0,
    CANCELED = 1,
    NO_SHOW = 2,
}

export class DocumentDto implements IDocumentDto {
    id?: string;
    name?: string;
    size?: number;
    type?: FileType;
    storageFileName?: string;
    downloadUrl?: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.storageFileName = _data["storageFileName"];
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["size"] = this.size;
        data["type"] = this.type;
        data["storageFileName"] = this.storageFileName;
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface IDocumentDto {
    id?: string;
    name?: string;
    size?: number;
    type?: FileType;
    storageFileName?: string;
    downloadUrl?: string | undefined;
}

export enum FileType {
    PDF = 0,
    DWG = 1,
}

export class AppointmentUserDto implements IAppointmentUserDto {
    id?: string;
    fullName?: string;
    isCompany?: boolean;

    constructor(data?: IAppointmentUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): AppointmentUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["isCompany"] = this.isCompany;
        return data;
    }
}

export interface IAppointmentUserDto {
    id?: string;
    fullName?: string;
    isCompany?: boolean;
}

export class AppointmentDetailsForUserResponse implements IAppointmentDetailsForUserResponse {
    id?: string;
    status?: AppointmentStatus;
    from?: Date;
    to?: Date;
    duration?: number;
    hasPdf?: boolean;
    hasAutoCAD?: boolean;
    documents?: DocumentDto[];
    isShortNotice?: boolean;

    constructor(data?: IAppointmentDetailsForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.hasPdf = _data["hasPdf"];
            this.hasAutoCAD = _data["hasAutoCAD"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.isShortNotice = _data["isShortNotice"];
        }
    }

    static fromJS(data: any): AppointmentDetailsForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDetailsForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["hasPdf"] = this.hasPdf;
        data["hasAutoCAD"] = this.hasAutoCAD;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        data["isShortNotice"] = this.isShortNotice;
        return data;
    }
}

export interface IAppointmentDetailsForUserResponse {
    id?: string;
    status?: AppointmentStatus;
    from?: Date;
    to?: Date;
    duration?: number;
    hasPdf?: boolean;
    hasAutoCAD?: boolean;
    documents?: DocumentDto[];
    isShortNotice?: boolean;
}

export class PaginationResponseOfAppointmentForAdminTableResponse implements IPaginationResponseOfAppointmentForAdminTableResponse {
    data?: AppointmentForAdminTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfAppointmentForAdminTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppointmentForAdminTableResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfAppointmentForAdminTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfAppointmentForAdminTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfAppointmentForAdminTableResponse {
    data?: AppointmentForAdminTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginationResponseOfAppointmentForAdminTableResponseAndInteger extends PaginationResponseOfAppointmentForAdminTableResponse implements IPaginationResponseOfAppointmentForAdminTableResponseAndInteger {
    additionalData?: number;

    constructor(data?: IPaginationResponseOfAppointmentForAdminTableResponseAndInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalData = _data["additionalData"];
        }
    }

    static override fromJS(data: any): PaginationResponseOfAppointmentForAdminTableResponseAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfAppointmentForAdminTableResponseAndInteger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalData"] = this.additionalData;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginationResponseOfAppointmentForAdminTableResponseAndInteger extends IPaginationResponseOfAppointmentForAdminTableResponse {
    additionalData?: number;
}

export class AppointmentForAdminTableResponse implements IAppointmentForAdminTableResponse {
    id?: string;
    from?: Date;
    to?: Date;
    duration?: number;
    clientEmail?: string;
    isCompany?: boolean;
    numOfAttachments?: number;
    status?: EnumDtoOfAppointmentStatus;
    isShortNotice?: boolean;

    constructor(data?: IAppointmentForAdminTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.clientEmail = _data["clientEmail"];
            this.isCompany = _data["isCompany"];
            this.numOfAttachments = _data["numOfAttachments"];
            this.status = _data["status"] ? EnumDtoOfAppointmentStatus.fromJS(_data["status"]) : undefined as any;
            this.isShortNotice = _data["isShortNotice"];
        }
    }

    static fromJS(data: any): AppointmentForAdminTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentForAdminTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["clientEmail"] = this.clientEmail;
        data["isCompany"] = this.isCompany;
        data["numOfAttachments"] = this.numOfAttachments;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["isShortNotice"] = this.isShortNotice;
        return data;
    }
}

export interface IAppointmentForAdminTableResponse {
    id?: string;
    from?: Date;
    to?: Date;
    duration?: number;
    clientEmail?: string;
    isCompany?: boolean;
    numOfAttachments?: number;
    status?: EnumDtoOfAppointmentStatus;
    isShortNotice?: boolean;
}

export class GetAppointmentsForAdminQuery extends PaginationFilter implements IGetAppointmentsForAdminQuery {
    filter?: AppointmentFilter;

    constructor(data?: IGetAppointmentsForAdminQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filter = _data["filter"] ? AppointmentFilter.fromJS(_data["filter"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetAppointmentsForAdminQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentsForAdminQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAppointmentsForAdminQuery extends IPaginationFilter {
    filter?: AppointmentFilter;
}

export class AppointmentFilter implements IAppointmentFilter {
    isUpcoming?: boolean | undefined;
    keyword?: string | undefined;
    isCompany?: boolean | undefined;

    constructor(data?: IAppointmentFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUpcoming = _data["isUpcoming"];
            this.keyword = _data["keyword"];
            this.isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): AppointmentFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUpcoming"] = this.isUpcoming;
        data["keyword"] = this.keyword;
        data["isCompany"] = this.isCompany;
        return data;
    }
}

export interface IAppointmentFilter {
    isUpcoming?: boolean | undefined;
    keyword?: string | undefined;
    isCompany?: boolean | undefined;
}

export class PaginationResponseOfClientAppointmentTableResponse implements IPaginationResponseOfClientAppointmentTableResponse {
    data?: ClientAppointmentTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfClientAppointmentTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClientAppointmentTableResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfClientAppointmentTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfClientAppointmentTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfClientAppointmentTableResponse {
    data?: ClientAppointmentTableResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ClientAppointmentTableResponse implements IClientAppointmentTableResponse {
    id?: string;
    from?: Date;
    to?: Date;
    status?: EnumDtoOfAppointmentStatus;
    isShortNotice?: boolean;
    isAttachmentMissing?: boolean;

    constructor(data?: IClientAppointmentTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.status = _data["status"] ? EnumDtoOfAppointmentStatus.fromJS(_data["status"]) : undefined as any;
            this.isShortNotice = _data["isShortNotice"];
            this.isAttachmentMissing = _data["isAttachmentMissing"];
        }
    }

    static fromJS(data: any): ClientAppointmentTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAppointmentTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["isShortNotice"] = this.isShortNotice;
        data["isAttachmentMissing"] = this.isAttachmentMissing;
        return data;
    }
}

export interface IClientAppointmentTableResponse {
    id?: string;
    from?: Date;
    to?: Date;
    status?: EnumDtoOfAppointmentStatus;
    isShortNotice?: boolean;
    isAttachmentMissing?: boolean;
}

export class GetClientAppointmentsQuery extends PaginationFilter implements IGetClientAppointmentsQuery {
    isUpcoming?: boolean;
    userId?: string;

    constructor(data?: IGetClientAppointmentsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isUpcoming = _data["isUpcoming"];
            this.userId = _data["userId"];
        }
    }

    static override fromJS(data: any): GetClientAppointmentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientAppointmentsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUpcoming"] = this.isUpcoming;
        data["userId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetClientAppointmentsQuery extends IPaginationFilter {
    isUpcoming?: boolean;
    userId?: string;
}

export class AppointmentForCalendarResponse implements IAppointmentForCalendarResponse {
    id?: string;
    from?: Date;
    to?: Date;
    clientName?: string;
    status?: EnumDtoOfAppointmentStatus;
    isCompany?: boolean;

    constructor(data?: IAppointmentForCalendarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.clientName = _data["clientName"];
            this.status = _data["status"] ? EnumDtoOfAppointmentStatus.fromJS(_data["status"]) : undefined as any;
            this.isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): AppointmentForCalendarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentForCalendarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["clientName"] = this.clientName;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["isCompany"] = this.isCompany;
        return data;
    }
}

export interface IAppointmentForCalendarResponse {
    id?: string;
    from?: Date;
    to?: Date;
    clientName?: string;
    status?: EnumDtoOfAppointmentStatus;
    isCompany?: boolean;
}

export class AppointmentForUserCalendarResponse implements IAppointmentForUserCalendarResponse {
    id?: string | undefined;
    from?: Date;
    to?: Date;
    isMine?: boolean;

    constructor(data?: IAppointmentForUserCalendarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.isMine = _data["isMine"];
        }
    }

    static fromJS(data: any): AppointmentForUserCalendarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentForUserCalendarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["isMine"] = this.isMine;
        return data;
    }
}

export interface IAppointmentForUserCalendarResponse {
    id?: string | undefined;
    from?: Date;
    to?: Date;
    isMine?: boolean;
}

export class AppointmentForUserTableResponse implements IAppointmentForUserTableResponse {
    id?: string;
    from?: Date;
    to?: Date;
    status?: AppointmentStatus;
    isFileMissing?: boolean;

    constructor(data?: IAppointmentForUserTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.status = _data["status"];
            this.isFileMissing = _data["isFileMissing"];
        }
    }

    static fromJS(data: any): AppointmentForUserTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentForUserTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["status"] = this.status;
        data["isFileMissing"] = this.isFileMissing;
        return data;
    }
}

export interface IAppointmentForUserTableResponse {
    id?: string;
    from?: Date;
    to?: Date;
    status?: AppointmentStatus;
    isFileMissing?: boolean;
}

export class AppointmentDocumentUploadUrlResponse implements IAppointmentDocumentUploadUrlResponse {
    storageFileName?: string;
    uploadUrl?: string;
    contentType?: string;

    constructor(data?: IAppointmentDocumentUploadUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageFileName = _data["storageFileName"];
            this.uploadUrl = _data["uploadUrl"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): AppointmentDocumentUploadUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDocumentUploadUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageFileName"] = this.storageFileName;
        data["uploadUrl"] = this.uploadUrl;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IAppointmentDocumentUploadUrlResponse {
    storageFileName?: string;
    uploadUrl?: string;
    contentType?: string;
}

export class AddAppointmentDocumentCommand implements IAddAppointmentDocumentCommand {
    appointmentId!: string;
    document!: AppointmentDocumentDto;

    constructor(data?: IAddAppointmentDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.document = new AppointmentDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.document = _data["document"] ? AppointmentDocumentDto.fromJS(_data["document"]) : new AppointmentDocumentDto();
        }
    }

    static fromJS(data: any): AddAppointmentDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddAppointmentDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        return data;
    }
}

export interface IAddAppointmentDocumentCommand {
    appointmentId: string;
    document: AppointmentDocumentDto;
}

export class AppointmentDocumentDto implements IAppointmentDocumentDto {
    name!: string;
    storageFileName!: string;
    type?: FileType;
    size?: number;

    constructor(data?: IAppointmentDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.storageFileName = _data["storageFileName"];
            this.type = _data["type"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): AppointmentDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["storageFileName"] = this.storageFileName;
        data["type"] = this.type;
        data["size"] = this.size;
        return data;
    }
}

export interface IAppointmentDocumentDto {
    name: string;
    storageFileName: string;
    type?: FileType;
    size?: number;
}

export class BookAppointmentCommand implements IBookAppointmentCommand {
    userId!: string;
    duration!: number;
    dateTime!: Date;
    pdf?: AppointmentDocumentDto | undefined;
    autoCad?: AppointmentDocumentDto | undefined;

    constructor(data?: IBookAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.duration = _data["duration"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
            this.pdf = _data["pdf"] ? AppointmentDocumentDto.fromJS(_data["pdf"]) : undefined as any;
            this.autoCad = _data["autoCad"] ? AppointmentDocumentDto.fromJS(_data["autoCad"]) : undefined as any;
        }
    }

    static fromJS(data: any): BookAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BookAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["duration"] = this.duration;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : undefined as any;
        data["autoCad"] = this.autoCad ? this.autoCad.toJSON() : undefined as any;
        return data;
    }
}

export interface IBookAppointmentCommand {
    userId: string;
    duration: number;
    dateTime: Date;
    pdf?: AppointmentDocumentDto | undefined;
    autoCad?: AppointmentDocumentDto | undefined;
}

export class RescheduleAppointmentCommand implements IRescheduleAppointmentCommand {
    id!: string;
    dateTime!: Date;

    constructor(data?: IRescheduleAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RescheduleAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RescheduleAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IRescheduleAppointmentCommand {
    id: string;
    dateTime: Date;
}

export class SwaggerResult<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}